import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import useRoutes from '../routes/useRoutes';
import StartPageView from '../views/StartPageView';
import MainLayout from './Layout/MainLayout';
import MenuView from '../views/MenuView';
import PPSIView from '../views/PPSIView'
import PPIView from '../views/PPIView'
import PrepAndProdCheatSheetView from '../views/PrepAndProdCheatSheetView'
import SettingsView from '../views/SettingsView'
import RedirectToMenu from './util/Redirect';
const Routes = () => {
  const routes = useRoutes();

  return (
    <Switch>
      <Route exact path="/" component={StartPageView}/>
      <Route exact path={routes.startPageRoute()} component={StartPageView}/>   
      <MainLayout exact path={routes.redirectRoute()}>
        <RedirectToMenu />
      </MainLayout>  
      <MainLayout  path={routes.menuRoute()} component={MenuView} />
      <MainLayout  path={routes.ppsiRoute()} component={PPSIView} />
      <MainLayout  path={routes.ppiRoute()} component={PPIView} />
      <MainLayout  
            
        path={routes.prepAndProdCheatSheetRoute()}
        component={PrepAndProdCheatSheetView}
      />
      <MainLayout  path={routes.settingsPageRoute()} component={SettingsView} />
      <MainLayout        
        path="*"
        exact
        component={({ location }) => (
          <Redirect
            to={{
              search: location.search,
              pathname: '/error'
              //pathname: routes.redirectRoute()
            }}
          />
        )}
      />
    </Switch>
  );
};

export default Routes;
